import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { CMS_BASE_URL } from "../../../axios";

const initialState = {
  opsLoading: false,
  healthcareGroups: [], //? AKA clinic groups
  allClinics: [],
  classesLoading: false,
  classesError: false,
  liveClassesEnrollmentData: [],
  singleClinicData: null,
  salesRevenue: null,
};

export const fetchHealthCareGroupsLogic = createAsyncThunk(
  "ops/healthcare-groups",
  (params) => {
    let config = {
      method: "get",
      url: `/api/clinic-group/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      params: params,
    };

    return axiosInstance.request(config);
  }
);

export const fetchHealthCareGroupsSolo = (params) => {
  let config = {
    method: "get",
    url: `/api/clinic-group/`,
    headers: {
      Authorization: `JWT ${localStorage.access}`,
      "Content-Type": "application/json",
    },
    params: params,
  };

  return axiosInstance.request(config).then().catch();
};

export const fetchTestHealthCareGroupsLogic = (params) => {
  let config = {
    method: "get",
    url: `/api/clinic-group/`,
    headers: {
      Authorization: `JWT ${localStorage.access}`,
      "Content-Type": "application/json",
    },
    params: params,
  };
  return axiosInstance.request(config).then().catch();
};

export const fetchAllClinicAdmins = (params = {}) => {
  return axiosInstance
    .get("/api/clinic-admin/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    })
    .then()
    .catch();
};

export const searchClinicsLogic = createAsyncThunk(
  "ops/search/clinics",
  (params) => {
    return axiosInstance.get("/api/clinic/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    });
  }
);

export const fetchLiveClassesEnrollmentLogic = createAsyncThunk(
  "ops/live-classes/enrollment",
  () => {
    return axiosInstance.get("/api/live-classes-enrollment/", {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    });
  }
);

export const fetchClinicInvoicingMetadata = (id = "") => {
  return axiosInstance
    .get(`/api/clinic-invoicing-metadata/${id}`, {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    })
    .then()
    .catch();
};

export const fetchLiveClassesLogic = () => {
  return axiosInstance
    .get(`${CMS_BASE_URL}/live-classes/`, {
      headers: { "Content-Type": "application/json" },
    })
    .then()
    .catch();
};

export const fetchSingleClinicDataLogic = createAsyncThunk(
  "ops/clinic/single",
  (id) => {
    return axiosInstance.get(`/api/clinic/${id}/`, {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    });
  }
);

export const fetchInvoicesFromDBLogic = createAsyncThunk(
  "invoices/getInvoices",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/invoice/get-invoices-from-db/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchInvoicesFromDB = (payload) => {
  //* payload = {start_date: 1971-02-14, end_date: 2023-08-03}
  return axiosInstance
    .post(`/api/invoice/get-invoices-from-db/`, JSON.stringify(payload), {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    })
    .then()
    .catch();
};

export const fetchClinicGroupInvoices = (payload) => {
  //payload: {clinic_group_id: 31, limit: 50}
  return axiosInstance
    .post(
      `/api/clinic-group-custom/get-all-invoices-of-a-clinic-group/`,
      JSON.stringify(payload),
      {
        headers: {
          Authorization: `JWT ${localStorage?.access}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then()
    .catch();
};

export const getClinicGroupInvoices = (months) => {
  return axiosInstance
    .get(`/api/get-clinic-group-invoices?months=${months}`, {
      headers: {
        Authorization: `JWT ${localStorage?.access}`,
        "Content-Type": "application/json",
      },
    })
    .then()
    .catch();
};

//* This is for the utilization page [monthwise patients count, graphdata, total patients count, new patient count, all clinic count]
export const getPatientCount = (months) => {
  return axiosInstance
    .get(`/api/patient-count/?months=${months}`, {
      "Content-Type": "application/json",
      Authorization: `JWT ${localStorage.access}`,
    })
    .then()
    .catch();
};

//* This is for the utilization page [Monthwise clinic count]
export const getClinicCount = (months) => {
  return axiosInstance
    .get(`/api/get-clinic-count/?months=${months}`)
    .then()
    .catch();
};

//*This is for the revenue page [Downloading csv data]
export const downloadRevenueCSV = (months) => {
  return axiosInstance
    .get(`/api/clinic-group-invoices-csv?months=${months}`)
    .then()
    .catch();
};

//*This is for the utilization page [Downloading csv data]
export const downloadUtilizationCSV = (months) => {
  return axiosInstance
    .get(`/api/get-patient-csv?months=${months}`)
    .then()
    .catch();
};

export const getSignedUpPatients = (months) => {
  return axiosInstance
    .get(`/api/get-signedup-patients?months=${months}`, {
      headers: {
        Authorization: `JWT ${localStorage?.access}`,
        "Content-Type": "application/json",
      },
    })
    .then()
    .catch();
};

export const getHealthcareGroupData = (months) => {
  const url = months
    ? `/api/get-healthcare-group-data?months=${months}`
    : `/api/get-healthcare-group-data`;
  return axiosInstance
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage?.access}`,
      },
    })
    .then()
    .catch();
};

//*This is for the Healthcare group page [Downloading csv data]
export const downloadHealthcareDataCSV = (months) => {
  const url = months
    ? `/api/get-healthcare-group-csv?months=${months}`
    : `/api/get-healthcare-group-csv`;
  return axiosInstance.get(url).then().catch();
};

//*This is for the Clinicians page
export const getClinicianData = (months) => {
  const url = months
    ? `/api/get-all-clinicians-data?months=${months}`
    : `/api/get-all-clinicians-data`;
  return axiosInstance
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage?.access}`,
      },
    })
    .then()
    .catch();
};

//*This is for the Clinicians page [Downloading csv data]
export const getClinicianDataCSV = (months) => {
  const url = months
    ? `/api/get-all-clinicians-csv?months=${months}`
    : `/api/get-all-clinicians-csv`;
  return axiosInstance.get(url).then().catch();
};

const opsAPICalls = {
  //* Fetch HealthCare GroupsData Promises
  [fetchHealthCareGroupsLogic.pending]: (state) => {
    state.opsLoading = true;
  },
  [fetchHealthCareGroupsLogic.fulfilled]: (state, { payload }) => {
    state.opsLoading = true;
    state.healthcareGroups = payload.data?.reverse();
    state.opsLoading = false;
  },
  [fetchHealthCareGroupsLogic.rejected]: (state, action) => {
    state.opsLoading = false;
  },

  //*Search Clinic Data Promises
  [searchClinicsLogic.pending]: (state) => {
    state.opsLoading = true;
  },
  [searchClinicsLogic.fulfilled]: (state, { payload }) => {
    state.allClinics = payload.data.reverse();
    state.opsLoading = false;
  },
  [searchClinicsLogic.rejected]: (state) => {
    state.opsLoading = false;
  },

  [fetchSingleClinicDataLogic.pending]: (state) => {
    state.opsLoading = true;
  },
  [fetchSingleClinicDataLogic.fulfilled]: (state, { payload }) => {
    state.opsLoading = false;
    state.singleClinicData = payload.data;
  },
  [fetchSingleClinicDataLogic.rejected]: (state) => {
    state.opsLoading = false;
  },

  //* Live Classes API Promises
  [fetchLiveClassesEnrollmentLogic.pending]: (state) => {
    state.classesLoading = true;
    state.classesError = false;
  },
  [fetchLiveClassesEnrollmentLogic.fulfilled]: (state, { payload }) => {
    state.liveClassesEnrollmentData = payload.data;
    state.classesLoading = false;
    state.classesError = false;
  },
  [fetchLiveClassesEnrollmentLogic.rejected]: (state) => {
    state.classesError = true;
    state.classesLoading = false;
  },
  //revenue API calls
  [fetchInvoicesFromDBLogic.pending]: (state) => {
    state.opsLoading = true;
  },
  [fetchInvoicesFromDBLogic.fulfilled]: (state, { payload }) => {
    state.salesRevenue = payload.data;
    state.opsLoading = false;
  },
  [fetchInvoicesFromDBLogic.rejected]: (state) => {
    state.opsLoading = false;
  },
};

const opsSlice = createSlice({
  name: "ops",
  initialState,
  extraReducers: (builder) => {
    Object.entries(opsAPICalls).forEach(([actionType, reducer]) => {
      builder.addCase(actionType, reducer);
    });
  },
  reducers: {
    fetchHealthCareGroups: fetchHealthCareGroupsLogic,
    searchClinics: searchClinicsLogic,
    fetchSingleClinicData: fetchSingleClinicDataLogic,
    fetchLiveClassesEnrollment: fetchLiveClassesEnrollmentLogic,
    fetchInvoicesFromDBCall: fetchInvoicesFromDBLogic,
  },
});

export const {
  fetchHealthCareGroups,
  searchClinics,
  fetchSingleClinicData,
  fetchLiveClassesEnrollment,
  fetchInvoicesFromDBCall,
} = opsSlice.actions;
export default opsSlice.reducer;
